import { Component, input } from '@angular/core';
import { DokaIcon } from '@doka/angular-core';
import { I18NextEagerPipe } from 'angular-i18next';

@Component({
  selector: 'app-empty-state',
  templateUrl: './empty-state.component.html',
  imports: [DokaIcon, I18NextEagerPipe],
})
export class EmptyStateComponent {
  public message = input<string>('EmptyState.NoData');
  public description = input<string | undefined>();
  public icon = input<string>('inbox');
}
